import { useForm } from 'react-hook-form';
import { TextLarge } from '../../../components/text';
import { FORM_EDIT_PRODUCT } from '../form';
import React, { useEffect } from 'react';
import { ContainerButton } from '../../../styles/global-style';
import { ProductTypesQuery, categoryQuery } from '../../../services/react-query/optionMasterQuery';
import { useUpdateProductList } from '../hooks/useUpdateProductList';
import { UpdateProductList } from '../../../resources/payload';
import { Spin } from 'antd';
import { PRODUCT_STATUS } from '../../../resources/status';
import { ModalTheme } from '../../../components/modal';
import { RenderForm } from '../../../components/forms';
import { ButtonTheme } from '../../../components/buttons';

export const EditProductModal = ({ open, onToggle, initialValues, onFetch }) => {
  const { control, getValues, setValue, handleSubmit } = useForm({});
  const { data: productTypeList } = ProductTypesQuery();
  const { mutate: updateProduct, loading: isLoadingUpdateProduct } = useUpdateProductList(onFetch);
  const { data: categoryList, isPending: loadingCategory } = categoryQuery();

  const productStatus = PRODUCT_STATUS?.map((status) => ({
    label: status?.label,
    value: status?.key,
  }));

  const onSubmit = () =>
    handleSubmit((values) => {
      values.isWarrantyNumberRequired = values.isWarrantyNumberRequired === 'ACTIVE' ? true : false;
      const formData = UpdateProductList(values);
      updateProduct(formData);
      onToggle({ defaultValue: '' });
    })();

  useEffect(() => {
    if (initialValues) {
      Object.keys(initialValues).forEach((key) => {
        let value = initialValues[key];

        if (key === 'isWarrantyNumberRequired') {
          value = value ? 'ACTIVE' : 'INACTIVE';
        }

        if (key === 'productImageUrl') {
          value = Array.isArray(value) ? value : value ? [{ uid: '-1', url: value }] : [];
        }

        setValue(key, value);
      });
    }
  }, [initialValues, setValue]);

  return (
    <Spin spinning={isLoadingUpdateProduct || loadingCategory}>
      <ModalTheme title=" " open={open} onToggle={onToggle}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <TextLarge text="แก้ไขสินค้า" />
        </div>
        <RenderForm
          control={control}
          getValues={getValues}
          setValue={setValue}
          forms={FORM_EDIT_PRODUCT({ productTypeList, productStatus, categoryList })}
        />
        <ContainerButton center>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ModalTheme>
    </Spin>
  );
};
